module.exports = __webpack_public_path__ + "fonts/AvenirRoman.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AvenirRoman.woff
// module id = 473
// module chunks = 12